// Template variables offered as chips (spec 08 §3).
export type TemplateVariable = {
  path: string;
  source: "contact" | "company" | "sender" | "deal" | "system";
  requiredForCampaign?: boolean;
};

export const TEMPLATE_VARIABLES: readonly TemplateVariable[] = Object.freeze([
  { path: "contact.first_name", source: "contact" },
  { path: "company.name", source: "company", requiredForCampaign: true },
  { path: "company.city", source: "company" },
  { path: "company.trade_label", source: "company" },
  { path: "rep.first_name", source: "sender" },
  { path: "rep.full_name", source: "sender" },
  { path: "rep.email", source: "sender" },
  { path: "rep.phone", source: "sender" },
  // GAVION video-campaign: the rep's enabled booking page (https://crm.gavion.ai/demo/<slug>), "" without one
  { path: "rep.booking_url", source: "sender" },
  { path: "deal.demo_at_fr", source: "deal" },
  { path: "deal.demo_at_en", source: "deal" }, // GAVION addition: English date for EN templates (spec 08 §3 lists only _fr)
  { path: "deal.teams_join_url", source: "deal" },
  { path: "unsubscribe_url", source: "system" },
  // GAVION missed-call: Paramètres → IA « Lien de la brochure » (https), "" when unset
  { path: "brochure_url", source: "system" },
]);

const KNOWN = new Set(TEMPLATE_VARIABLES.map((v) => v.path));
export const isKnownVariable = (path: string): boolean => KNOWN.has(path);
export const unknownVariables = (paths: readonly string[]): string[] => [
  ...new Set(paths.filter((p) => !KNOWN.has(p))),
];
export const REQUIRED_FOR_CAMPAIGN: readonly string[] =
  TEMPLATE_VARIABLES.filter((v) => v.requiredForCampaign).map((v) => v.path);
